export { BaseMessageComponent } from './base-message.component';
